import { Divider, HStack, VStack, Box, Text, DataList, DataItem } from '@cad-arc';
import { observer } from 'mobx-react-lite';
import { useEnabledFeatures } from '../../../../common/hooks/enabled-features/use-enabled-features';
import { MapLedgerEventView } from '@mark43/cad-api';
import { CommonSize, getOneSizeSmaller } from '../../../../common/helpers/utils';
import { getDataItemText } from '../../../../common/helpers/component-utils';

export const EventInfoSection = observer(function EventInfoSection({
    selectedMapLedgerEvent,
    size,
}: {
    selectedMapLedgerEvent: MapLedgerEventView;
    size?: CommonSize;
}): React.ReactElement {
    const { multiAgencySubdivisions, staffCountEnabled, eventLocationNotes } = useEnabledFeatures();

    const {
        agencyName,
        subdivisions,
        dispatchArea,
        narrative,
        eventLocationNotes: locationNotes,
        staffCount,
    } = selectedMapLedgerEvent || {};

    const subdivisionLabel = multiAgencySubdivisions ? `${agencyName} Subd.` : 'Subdivisions';

    const smallerSize = getOneSizeSmaller(size);

    return (
        <Box data-testid="MAP_EVENT_INFO_SECTION">
            <VStack alignItems="start" padding="12px 18px" spacing={3}>
                <Text fontSize={size} fontWeight="bold">
                    Event Info
                </Text>
                <DataList
                    direction="column"
                    variant="stacked"
                    spacing={3}
                    style={{ width: '100%' }}
                >
                    <HStack alignItems="flex-start" gap={4}>
                        <DataItem
                            dataKey={<Text fontSize={smallerSize}>{subdivisionLabel}</Text>}
                            style={{ flexBasis: '50%', wordBreak: 'break-word' }}
                        >
                            {getDataItemText(size, subdivisions)}
                        </DataItem>

                        <DataItem
                            dataKey={<Text fontSize={smallerSize}>D-Area</Text>}
                            style={{ flexBasis: '50%', wordBreak: 'break-word' }}
                        >
                            {getDataItemText(size, dispatchArea)}
                        </DataItem>
                    </HStack>
                    {staffCountEnabled && (
                        <DataItem
                            dataKey={<Text fontSize={smallerSize}>Staff Count</Text>}
                            style={{ wordBreak: 'break-word' }}
                        >
                            {getDataItemText(size, staffCount ?? 0)}
                        </DataItem>
                    )}
                    <DataItem
                        dataKey={<Text fontSize={smallerSize}>Initial Narrative</Text>}
                        style={{ wordBreak: 'break-word' }}
                    >
                        {getDataItemText(size, narrative)}
                    </DataItem>
                    {eventLocationNotes && (
                        <DataItem
                            dataKey={<Text fontSize={smallerSize}>Location Notes</Text>}
                            style={{ wordBreak: 'break-word' }}
                        >
                            {getDataItemText(size, locationNotes)}
                        </DataItem>
                    )}
                </DataList>
            </VStack>
            <Divider />
        </Box>
    );
});
